import client from '@/lib/http-client';
import { buildQuery } from '@/lib/helper';
import { statItems } from '@/lib/statics';

const endpoint = '/statistic';

export default {
	/**
	 *
	 * @param {Object} params Request Params
	 * @param {string} params.product_id Product ID
	 * @param {'YYYY-MM-DD'} params.since Start Date
	 * @param {'YYYY-MM-DD'} params.until End Date
	 * @param {requestCallback} cb Response Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	getFunnel(params, cb, errorCb) {
		const url = `${endpoint}/funnel`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	setStatisticCategories(params, cb, errorCb) {
		const url = `${endpoint}/category`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getAppStats(params, cb, errorCb, sourceToken) {
		const items = statItems.join(',');
		params.items = items;

		const query = buildQuery(params);
		const url = `${endpoint}/app?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { cancelToken: sourceToken })
			.then(responseHandler)
			.catch(errorHandler);
	},

	getAppStatsNew(params, cb, errorCb, sourceToken) {
		if (!params.items) {
			const items = statItems.join(',');
			params.items = items;
		}
		const query = buildQuery(params);
		const url = `${endpoint}/app/new?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { cancelToken: sourceToken })
			.then(responseHandler)
			.catch(errorHandler);
	},

	getSupplierProductsStats(params, cb, errorCb, sourceToken) {
		if (!params.items) {
			const items = statItems.join(',');
			params.items = items;
		}
		const query = buildQuery(params);
		const url = `${endpoint}/supplier/product-stats?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { cancelToken: sourceToken })
			.then(responseHandler)
			.catch(errorHandler);
	},

	getTeamStats(params, cb, errorCb) {
		const url = `${endpoint}/team_performance`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	getContactStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/contact?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	getResellerStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/reseller?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
	getStatisticCategories(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/category?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	getContactRegionStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/contact/region?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	getExpenseStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/expense?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Logistic Stats
	getLogisticStats(params, cb, errorCb) {
		const url = `${endpoint}/logistic`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Logistic Stats - New Version
	getLogisticStatsNew(params, cb, errorCb) {
		const url = `${endpoint}/logistic-new`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Admin Logistic Stats
	getAdminLogisticStats(params, cb, errorCb) {
		const url = `${endpoint}/admin/logistic`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Admin Logistic Stats - New Version
	getAdminLogisticStatsNew(params, cb, errorCb) {
		const url = `${endpoint}/admin/logistic-new`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Logistic Region Stats
	getLogisticRegionStats(params, cb, errorCb) {
		const url = `${endpoint}/logistic/region`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Admin Logistic Region Stats
	getAdminLogisticRegionStats(params, cb, errorCb) {
		const url = `${endpoint}/admin/logistic/region`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Admin Finance Stats
	getAdminFinanceStats(params, cb, errorCb) {
		const url = `${endpoint}/admin/finance`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	* Calculate Statistic Order
	* @param {Object} params Request Params
	* @param {requestCallback} cb
	* @param {errorCallback} errorCb
	*/
	calculateStatisticOrder(params, cb, errorCb) {
		const url = `${endpoint}/calculate-order-statistic`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
